module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (29).61619a0a.jpg";